// extracted by mini-css-extract-plugin
module.exports = {"lia-has-unread":"SpotlightSearchIcon_lia-has-unread__bjy88","lia-unread-badge":"SpotlightSearchIcon_lia-unread-badge__0dw1D"};